import { render, staticRenderFns } from "./PickingForm.vue?vue&type=template&id=3b631bde&scoped=true"
import script from "./PickingForm.vue?vue&type=script&lang=js"
export * from "./PickingForm.vue?vue&type=script&lang=js"
import style0 from "./PickingForm.vue?vue&type=style&index=0&id=3b631bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b631bde",
  null
  
)

export default component.exports